<template>
<div class="vhc-container">
  <!-- 标题栏 -->
  <pageTitle :pageTitle="$t('lang.k_202001')">
    <div slot="content">
      {{ $t('lang.k_202002')}}
      <br />
      {{ $t('lang.k_202003')}}
      <br />
      {{ $t('lang.k_202004')}}
    </div>
  </pageTitle>

  <!-- tabs -->
  <vh-tabs class="interactive-prize-tabs" v-model="activeTab" @tab-click="handleTabClick">
    <vh-tab-pane :label="$t('lang.k_202005')" name="1">
      <TaskList v-if="activeTab === '1'"></TaskList>
    </vh-tab-pane>
    <vh-tab-pane :label="$t('lang.k_202006')" name="2">
      <RewardList v-if="activeTab === '2'"></RewardList>
    </vh-tab-pane>
  </vh-tabs>

  <begin-play :webinarId="$route.params.str"></begin-play>
</div>
</template>
<script>
import PageTitle from '@/components/PageTitle';
import TaskList from './TaskList.vue';
import RewardList from './RewardList.vue';
import beginPlay from '@/components/beginBtn';
export default {
  name: 'InteractReward',
  components: {
    PageTitle,
    TaskList,
    RewardList,
    beginPlay
  },
  data() {
    return {
      activeTab: '1'
    };
  },
  methods: {
    handleTabClick() {
      this.$router.replace({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          tab: this.activeTab
        }
      });
    }
  },
  created() {
    this.activeTab = this.$route.query.tab || '1';
  }
};
</script>
<style lang="less">
  .interactive-prize-tabs {
    background-color: #fff;

    .vh-tabs__header {
      margin: 0;
      // padding: 0;
      .vh-tabs__nav-wrap {
        padding-right: 20px;
        &::after {
          background-color: #e6e6e6;
        }
      }
    }
    .vh-tabs__item {
      height: 48px;
      line-height: 48px;
      font-size: 16px;
    }
    .vh-tabs__content {
      // padding: 0;
    }
  }
</style>
